/**
 * 该文件为脚本自动生成文件，请勿随意修改。如需修改请联系 PMC
 * */

import { TdColorPickerProps } from './type';

export const colorPickerDefaultProps: TdColorPickerProps = {
  clearable: false,
  enableAlpha: false,
  fixed: false,
  format: 'RGB',
  type: 'base',
};
